exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ImpersonationView{display:flex;position:fixed;top:0;width:100%;justify-content:right;z-index:999;border-top:5px solid #f44336;padding:0 25px;height:5px}#ImpersonationView .v-speed-dial__list{top:50px}", ""]);

// exports
